import {invokeApi} from "../utils/invokeApi";
import {LOCAL_STORAGE_KEYS} from "../utils/constants";

export const getOrgByAppKey = (app_key) => {
    let requestObj = {
        path   : '/my_dq/app_start/get_org',
        method : 'POST'
    };
    const postData = {
        app_key
    };
    requestObj['postData'] = postData;

    return invokeApi(requestObj);
}

export const getGuestUser = (org_code, user_group) => {
    let requestObj = {
        path   : `/my_dq/app_start/guest_user`,
        method : 'POST',
        headers : {
            'xc-org-code': org_code
        }
    };
    if (user_group) {
        requestObj['postData'] = {
            user_group,
        };
    }

    return invokeApi(requestObj);
}

export const saveUserGroup = (user_group) => {
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/app_start/save_user_group`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`
        }
    };
    requestObj['postData'] = {
        user_group,
    };

    return invokeApi(requestObj);
}

export const saveDemographics = (
        gender,
        year_of_birth,
        country,
        postal_code,
        state,
        state_code
    ) => {
    const locale = localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_LOCALE);
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/app_start/update_demographic`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`,
            'xc-dq-locale': locale
        }
    };
    requestObj['postData'] = {
        gender,
        year_of_birth,
        country,
        postal_code,
        state,
        state_code
    };

    return invokeApi(requestObj);
}

/**
 * The "Is this you?" payload — the eight fields the learner may correct,
 * their labels, whether they have already been asked, and any request of
 * theirs still waiting on the school.
 *
 * The learner comes from the token and the org from the app key, so this can
 * only ever return their own profile.
 */
export const fetchProfileConfirmation = () => {
    const locale = localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_LOCALE);
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    return invokeApi({
        path: `/my_dq/app_start/profile/confirmation`,
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'xc-dq-locale': locale,
        },
        postData: {},
    });
};

/**
 * "Yes, this is all correct." Records that the learner has been asked and
 * writes nothing else — confirming is not a change, so the school never sees
 * it in their queue.
 */
export const confirmProfile = () => {
    const locale = localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_LOCALE);
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    return invokeApi({
        path: `/my_dq/app_start/profile/confirm`,
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'xc-dq-locale': locale,
        },
        postData: {},
    });
};

/**
 * "Send to my school" — the corrected values, as ONE request.
 *
 * `fields` is any subset of first_name, last_name, student_email,
 * year_of_birth, gender, country, state, postal_code. Nothing here reaches
 * the profile: the server records the difference and the school decides.
 */
export const submitProfileChanges = (fields) => {
    const locale = localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_LOCALE);
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    return invokeApi({
        path: `/my_dq/app_start/profile/submit_changes`,
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'xc-dq-locale': locale,
        },
        postData: { ...fields },
    });
};

export const fetchDQWRedirectLink = (redirect_back_link) => {
    const locale = localStorage.getItem(LOCAL_STORAGE_KEYS.ACTIVE_LOCALE);
    const token = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN));
    let requestObj = {
        path   : `/my_dq/app_start/dqw_redirect`,
        method : 'POST',
        headers : {
            Authorization : `Bearer ${token}`,
            'xc-dq-locale': locale
        }
    };
    requestObj['postData'] = {
        redirect_back_link
    };

    return invokeApi(requestObj);
}